import { useRequest } from "../../../hooks/useRequest";
import { useCallback, useEffect } from "react";
import { useUpdateSolutionDetails } from "./useUpdateSolutionDetails";
import useSolutionStripeLink from "./useSolutionStripeLink";
import routes from "../../../routes";

function useSolutionDetails(solutionId: string) {
  const updateSolutionDetails = useUpdateSolutionDetails(solutionId);
  const linkToStripe = useSolutionStripeLink(solutionId);

  const { fetch, response, error, loading } = useRequest();

  const fetchSolutionDetails = useCallback(
    () => fetch("GET", routes.api.solution.individual({ id: solutionId })),

    [fetch, solutionId],
  );

  const isEditSolutionSuccess = useCallback(
    () =>
      (updateSolutionDetails.alert &&
        updateSolutionDetails.alert.type !== "error") ||
      (linkToStripe.alert && linkToStripe.alert.type === "success"),
    [updateSolutionDetails.alert, linkToStripe.alert],
  );
  useEffect(() => {
    fetchSolutionDetails();
  }, [solutionId, fetchSolutionDetails]);

  useEffect(() => {
    if (isEditSolutionSuccess()) {
      fetchSolutionDetails();
    }
  }, [
    solutionId,
    updateSolutionDetails.alert,
    linkToStripe.alert,
    fetchSolutionDetails,
    isEditSolutionSuccess,
  ]);

  return {
    linkToStripe,
    updateSolutionDetails,
    details: response?.data,
    error,
    loading,
  };
}

export default useSolutionDetails;
